// extracted by mini-css-extract-plugin
export var productImage = "_pl-1";
export var viewLink = "_pl-2";
export var wishlistItem = "_pl-0";